/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-10.
 * Form configuration for "user"
 */
import { SELECT, TEXT } from '../components/data-containers/formBuilder/types';
import { USER_ROLES } from '../data/selects';

export const getConfig = (actions = {}) => {
    return {
        fields: [
            {
                fType: TEXT,
                key: 'name',
                floatingLabelFixed: true,
                floatingLabelText: 'Nombre Completo',
                hintText: 'Javier Ochoa Valdivia',
                fullWidth: true,
                value: ''
            },
            {
                fType: TEXT,
                key: 'email',
                floatingLabelFixed: true,
                floatingLabelText: 'Correo Electrónico',
                hintText: 'usuario@ssf.com.mx',
                fullWidth: true,
                value: ''
            },
            {
                fType: TEXT,
                key: 'email2',
                floatingLabelFixed: true,
                floatingLabelText: 'Confirmar Correo',
                hintText: 'usuario@ssf.com.mx',
                fullWidth: true,
                value: ''
            },
            {
                fType: SELECT,
                key: 'role',
                floatingLabelText: 'Rol de Usuario',
                floatingLabelFixed: true,
                data: USER_ROLES
            }
        ],
        rules: {
            role: [{ key: 'required', errorText: 'Campo requerido' }],
            name: [{ key: 'required', errorText: 'Campo requerido' }],
            email: [
                { key: 'required', errorText: 'Campo requerido' },
                { key: 'validationEmail', errorText: 'Ingrese un correo válido' },
                { key: 'SaveEmail1Value', errorText: 'Ingrese correo vàlido 2' }
            ],
            email2: [
                { key: 'ConfirmEmail', errorText: 'Asegurese que el correo sea igual' }
            ]
        }
    };
};



// WEBPACK FOOTER //
// ./forms/user.js